<script setup lang="ts">
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';
import { onMounted, ref, toRefs } from 'vue';
import { VButton } from '@shared/component/VButton';
import RelatiegegevensEmbed from '../RelatiegegevensEmbed.vue';

const props = defineProps<{
  relatienummer: number;
}>();

const { relatienummer } = toRefs(props);

const embed = ref();

onMounted(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('schadenummer')) {
    embed.value.click(`tr[data-claimnumberintern="${params.get('schadenummer')}"]`);
  }
  if (params.get('tab') === 'uitkeringen') {
    embed.value.click('a[href="#claim-uitkeringen"]');
  }
});
</script>

<template>
  <VPageContainer container-size="sm" gap="xs" title="Schades">
    <template #actions>
      <VButton
        prepend-icon="far fa-download"
        inverted
        :href="`/net/report/schadeoverzichtrel?relatienr=${relatienummer}`"
      >
        Schadeoverzicht
      </VButton>
    </template>
    <RelatiegegevensEmbed ref="embed" :relatienummer="relatienummer" tab="schades" />
  </VPageContainer>
</template>
